"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getTime_1 = __importDefault(require("./util/getTime"));
const generateStreemEndeavorId = (fromUserId, toUserId) => {
    const d = new Date();
    const year = d.getFullYear();
    const date = d.getDate();
    const month = d.getMonth() + 1;
    const dateTime = `${year}${month < 10 ? '0' + month : month}${date < 10 ? '0' + date : date}:${(0, getTime_1.default)()}`;
    return `${fromUserId}-${toUserId}-${dateTime}`;
};
exports.default = generateStreemEndeavorId;
//# sourceMappingURL=generateStreemEndeavorId.js.map